import { holatVar } from "@/shared/charts/palette";
import { SegmentBar } from "@/shared/charts/SegmentBar";

export interface SplitBarProps {
	title: string;
	/** ⚠️ Sarlavha ostidagi izoh — kogorta o'lchamini AYNAN shu satr aytadi. */
	subtitle: string;
	chapYorliq: string;
	chapQiymat: number;
	ongYorliq: string;
	ongQiymat: number;
}

/**
 * Ikki bo'lakli nisbat chizig'i — `shared/charts/SegmentBar` moslamasi.
 *
 * ⚠️ **Legendada RAQAM bor va bu MAJBURIY** — diagramma faqat rang
 * bilan ma'no bermaydi.
 *
 * ⚠️ O'ng bo'lak NEYTRAL kulrang, qizil EMAS: «Tashqarida» — buzilish
 * emas, holat.
 *
 * ⚠️ Jami nol (bo'sh kogorta) — `SegmentBar` bo'lak chizmaydi, NaN yo'q.
 *
 * ⚠️ **`data-split-title` va `data-split-legend` konteynerlari TEST
 * KONTRAKTI** — sahifa testi sanoqlarni aynan shu konteynerlardan
 * o'qiydi, sahifa bo'ylab `textContent` bilan emas.
 */
export function SplitBar({
	title,
	subtitle,
	chapYorliq,
	chapQiymat,
	ongYorliq,
	ongQiymat,
}: SplitBarProps) {
	return (
		<div>
			<div data-split-title className="flex items-baseline gap-2">
				<span className="font-medium text-[12.5px]">{title}</span>
				<span className="text-xs" style={{ color: holatVar("neytral") }}>
					{subtitle}
				</span>
			</div>

			<div data-split-legend className="mt-2">
				<SegmentBar
					segments={[
						{ key: "chap", value: chapQiymat, color: holatVar("kelgan"), label: chapYorliq },
						{ key: "ong", value: ongQiymat, color: holatVar("neytral"), label: ongYorliq },
					]}
				/>
			</div>
		</div>
	);
}
